// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  width: 100%;
  background: var(--sebrae-light-gray);
  padding-top: 49px;
  color: var(--sebrae-blue-6);
}
.footer .container {
  max-width: 1376px !important;
}
.footer .logo {
  display: inline-block;
}
.footer-top {
  text-align: center;
  padding-bottom: 32px;
}
.footer-top .container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
.footer-bottom {
  width: 100%;
  padding: 16px 0;
  margin-top: 16px;
  border-top: 1px solid var(--sebrae-blue-6);
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
}
.footer .phone p {
  font-size: 14px;
  margin-bottom: 8px;
}
.footer .phone a {
  color: var(--sebrae-blue-6);
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
}
.footer .socials, .footer .apps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}
.footer .download-socials-logo {
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
}
.footer .download-socials-logo .download {
  display: none;
}
.footer .download-socials-logo .download p {
  font-size: 13px;
  margin-bottom: 5px;
  line-height: 1.2;
}
.footer.type-auth {
  padding-top: 0;
}
.footer.type-auth .link-button {
  color: var(--sebrae-blue-6);
  width: 100%;
  border-bottom: 1px solid var(--sebrae-blue-6);
  padding: 16px;
  height: 51px;
  margin-bottom: 16px;
  background: transparent;
  text-align: left;
  text-decoration: none;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.footer.type-auth .footer-top {
  padding-bottom: 0;
}
.footer.type-auth .footer-top .container {
  align-items: flex-start;
  gap: 18px;
}
.footer.type-auth .footer-bottom {
  border: none;
  text-align: left;
  margin-top: 0;
}
.footer.type-auth .phone {
  text-align: left;
}
.footer.type-auth .phone a {
  font-size: 13px;
}
.footer.type-auth .socials {
  padding-left: 8px;
}
@media screen and (min-width: 375px) {
  .footer-bottom {
    font-size: 12px;
  }
}
@media screen and (min-width: 768px) {
  .footer .download-socials-logo .download {
    display: block;
  }
}
@media screen and (min-width: 1024px) {
  .footer {
    padding-top: 16px;
  }
  .footer .logo {
    width: 204px;
  }
  .footer-top {
    padding-bottom: 0;
  }
  .footer-top .container {
    flex-direction: row;
    justify-content: flex-start;
    gap: 7%;
  }
  .footer-bottom {
    font-size: 13px;
  }
  .footer .phone p {
    font-size: 13px;
  }
  .footer .phone a {
    font-size: 23px;
  }
  .footer .socials, .footer .apps {
    gap: 12px;
  }
  .footer .download-socials-logo {
    flex-direction: row;
    justify-content: flex-end;
    gap: 18px;
    flex: 1 1;
  }
  .footer .download-socials-logo .download {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-right: 12px;
    border-right: 1px solid var(--sebrae-blue-6);
  }
  .footer .download-socials-logo .download p {
    margin: 0;
  }
  .footer .download-socials-logo .logo {
    width: 82px;
  }
  .footer.type-auth .container {
    max-width: 1320px !important;
  }
  .footer.type-auth .link-button {
    display: inline-block;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    border: none;
    text-align: left;
  }
  .footer.type-auth .link-button svg {
    display: none;
  }
  .footer.type-auth .footer-top {
    width: 100%;
    max-width: 1320px !important;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .footer.type-auth .footer-top .container {
    justify-content: flex-end;
    flex: 1 1;
  }
  .footer.type-auth .footer-bottom {
    border-top: 1px solid var(--sebrae-blue-6);
  }
  .footer.type-auth .phone {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .footer.type-auth .phone p {
    margin: 0;
  }
  .footer.type-auth .socials {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/footer/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,oCAAA;EACA,iBAAA;EACA,2BAAA;AACF;AACE;EACE,4BAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;EACA,oBAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACN;AAEE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAGI;EACE,eAAA;EACA,kBAAA;AADN;AAGI;EACE,2BAAA;EAEE,eAAA;EACA,gBAAA;EAEF,qBAAA;AAHN;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAJJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,aAAA;AAJN;AAMM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AASE;EACE,cAAA;AAPJ;AASI;EACE,2BAAA;EACA,WAAA;EACA,6CAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EAEE,gBAAA;EACA,qBAAA;EAEF,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kDAAA;AATN;AAWI;EACE,iBAAA;AATN;AAWM;EACE,uBAAA;EACA,SAAA;AATR;AAYI;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AAVN;AAYI;EACE,gBAAA;AAVN;AAYM;EACE,eAAA;AAVR;AAaI;EACE,iBAAA;AAXN;AAeE;EACE;IACE,eAAA;EAbJ;AACF;AAeE;EAEI;IACE,cAAA;EAdN;AACF;AAiBE;EAjIF;IAkII,iBAAA;EAdF;EAgBE;IACE,YAAA;EAdJ;EAgBE;IACE,iBAAA;EAdJ;EAgBI;IACE,mBAAA;IACA,2BAAA;IACA,OAAA;EAdN;EAiBE;IACE,eAAA;EAfJ;EAkBI;IACE,eAAA;EAhBN;EAkBI;IACE,eAAA;EAhBN;EAmBE;IACE,SAAA;EAjBJ;EAmBE;IACE,mBAAA;IACA,yBAAA;IACA,SAAA;IACA,SAAA;EAjBJ;EAmBI;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,mBAAA;IACA,4CAAA;EAjBN;EAmBM;IACE,SAAA;EAjBR;EAoBI;IACE,WAAA;EAlBN;EAuBI;IACE,4BAAA;EArBN;EAwBI;IACE,qBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;EAtBN;EAwBM;IACE,aAAA;EAtBR;EAyBI;IACE,WAAA;IACA,4BAAA;IACA,cAAA;IACA,aAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;EAvBN;EAyBM;IACE,yBAAA;IACA,SAAA;EAvBR;EA0BI;IACE,0CAAA;EAxBN;EA0BI;IACE,aAAA;IACA,mBAAA;IACA,QAAA;EAxBN;EA0BM;IACE,SAAA;EAxBR;EA2BI;IACE,aAAA;EAzBN;AACF","sourcesContent":[".footer {\n  width: 100%;\n  background: var(--sebrae-light-gray);\n  padding-top: 49px;\n  color: var(--sebrae-blue-6);\n\n  .container {\n    max-width: 1376px!important;\n  }\n  .logo {\n    display: inline-block;\n  }\n  &-top {\n    text-align: center;\n    padding-bottom: 32px;\n\n    .container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 32px;\n    }\n  }\n  &-bottom {\n    width: 100%;\n    padding: 16px 0;\n    margin-top: 16px;\n    border-top: 1px solid var(--sebrae-blue-6);\n    text-align: center;\n    font-size: 11px;\n    line-height: 1.2;\n  }\n  .phone {\n    p {\n      font-size: 14px;\n      margin-bottom: 8px;\n    }\n    a {\n      color: var(--sebrae-blue-6);\n      font: {\n        size: 24px;\n        weight: 700;\n      }\n      text-decoration: none;\n    }\n  }\n  .socials, .apps {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 18px;\n  }\n  .download-socials-logo {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    justify-content: center;\n    align-items: center;\n\n    .download {\n      display: none;\n\n      p {\n        font-size: 13px;\n        margin-bottom: 5px;\n        line-height: 1.2;\n      }\n    }\n  }\n\n  &.type-auth {\n    padding-top: 0;\n\n    .link-button {\n      color:  var(--sebrae-blue-6);\n      width: 100%;\n      border-bottom: 1px solid var(--sebrae-blue-6);\n      padding: 16px;\n      height: 51px;\n      margin-bottom: 16px;\n      background: transparent;\n      text: {\n        align: left;\n        decoration: none;\n      }\n      font-size: 13px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n    .footer-top {\n      padding-bottom: 0;\n\n      .container {\n        align-items: flex-start;\n        gap: 18px;\n      }\n    }\n    .footer-bottom {\n      border: none;\n      text-align: left;\n      margin-top: 0;\n    }\n    .phone {\n      text-align: left;\n\n      a {\n        font-size: 13px;\n      }\n    }\n    .socials {\n      padding-left: 8px;\n    }\n  }\n\n  @media screen and (min-width: 375px) {\n    &-bottom {\n      font-size: 12px;\n    }\n  }\n  @media screen and (min-width: 768px) {\n    .download-socials-logo {\n      .download {\n        display: block;\n      }\n    }\n  }\n  @media screen and (min-width: 1024px) {\n    padding-top: 16px;\n\n    .logo {\n      width: 204px;\n    }\n    &-top {\n      padding-bottom: 0;\n\n      .container {\n        flex-direction: row;\n        justify-content: flex-start;\n        gap: 7%;\n      }\n    }\n    &-bottom {\n      font-size: 13px;\n    }\n    .phone {\n      p {\n        font-size: 13px;\n      }\n      a {\n        font-size: 23px;\n      }\n    }\n    .socials, .apps {\n      gap: 12px;\n    }\n    .download-socials-logo {\n      flex-direction: row;\n      justify-content: flex-end;\n      gap: 18px;\n      flex: 1;\n\n      .download {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding-right: 12px;\n        border-right: 1px solid var(--sebrae-blue-6);\n\n        p {\n          margin: 0;\n        }\n      }\n      .logo {\n        width: 82px;\n      }\n    }\n\n    &.type-auth {\n      .container {\n        max-width: 1320px!important;\n      }\n\n      .link-button {\n        display: inline-block;\n        width: auto;\n        height: auto;\n        padding: 0;\n        margin: 0;\n        border: none;\n        text-align: left;\n\n        svg {\n          display: none;\n        }\n      }\n      .footer-top {\n        width: 100%;\n        max-width: 1320px!important;\n        margin: 0 auto;\n        padding: 24px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        .container {\n          justify-content: flex-end;\n          flex: 1;\n        }\n      }\n      .footer-bottom {\n        border-top: 1px solid var(--sebrae-blue-6);\n      }\n      .phone {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n\n        p {\n          margin: 0;\n        }\n      }\n      .socials {\n        display: none;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
